import { Button, type ButtonProps } from "@mui/material";
import type { ElementType } from "react";

export default function TextButton<C extends ElementType = "button">({
  sx,
  ...props
}: ButtonProps<C> & { component?: C }) {
  return (
    <Button
      variant="text"
      disableRipple
      sx={{
        color: "text.accent",
        textDecoration: "underline",
        minWidth: "auto",
        background: "transparent",
        p: 0,
        "&:hover": { backgroundColor: "transparent" },
        ...sx,
      }}
      {...props}
    />
  );
}
